<p *ngIf="companyList?.length == 0">Non sono presenti società</p>
<div class="row">
  <div class="col-12">
    <table *ngIf="companyList?.length > 0" class="table">
      <caption class="sr-only">Tabella lista società</caption>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Tipo società</th>
          <th></th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let company of companyList">
          <td>{{ company?.name }}</td>
          <td>{{ company?.type?.name}}</td>


          <td class="col-xs-3 cell">
            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li>
                        <span class="glyphicon ml-0 glyphicon-pencil span-icon"></span>
                        <a href="javascript:void(0)" (click)="onEditCompany(company)">Modifica</a>
                      </li>
                      <li>
                        <span class="glyphicon ml-0 glyphicon-trash span-icon"></span>
                        <a href="javascript:void(0)" (click)="onDeleteCompany(company)">Elimina</a>
                      </li>
                      <li>
                        <span class="glyphicon ml-0 glyphicon glyphicon-cog span-icon"></span>
                        <a href="javascript:void(0)" [routerLink]="['dettaglio', company.id]">Dettagli società
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

